import React from "react";
import type { PropsWithChildren } from "react";
import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";

/** Shared with `PageHeaderBar`, so its inner content lines up with the body below it. */
export const pageContentMaxWidth = 1440;

/** The gap between the edge of the centered content and its cards/header row. */
export const pageContentPadding = "24px 32px";

type PageContentProps = PropsWithChildren<{
  /** `false` keeps the padding but drops the width cap, for a page that wants to fill the screen. */
  maxWidth?: number | false;
  sx?: SxProps<Theme>;
}>;

/**
 * Caps a detail page's body at a fixed width and centers it, so wide screens don't stretch a quote's
 * cards edge-to-edge. Pair with `PageHeaderBar` above it for a page whose header bar spans the full
 * width but whose content lines up with this.
 * @param props
 */
export function PageContent(props: PageContentProps) {
  const { children, maxWidth = false, sx } = props;
  return (
    <Box
      sx={{
        boxSizing: "border-box",
        ...(maxWidth !== false && { maxWidth, mx: "auto" }),
        padding: pageContentPadding,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
